<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="cf_workers"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="buttons"
            :addButton="{ permission: 'worker:create' }"
            :deleteButton="{ permission: 'worker:delete' }"
            :updateButton="{ enabled: false, permission: 'worker:update' }"
        >
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `WorkerAttendance`,
    props: {},
    data() {
        return {
            title: `考勤管理`,
            dic_attendancePlan_names: [],
            dic_attendancePlan_contents: [],
            url: {
                baseURL: `/api/AcisSystem/WorkerAttendance`,
                get: () => {
                    return new Promise(resolve => {
                        let wks = this.myaxios.get(`/api/AcisSystem/WorkerAttendance/Get`)
                        wks.then(data => {
                            resolve(data)
                        })
                    })
                }
            },
            buttons: [{
                class: `is-plain`,
                label: `编辑`,
                type: `primary`,
                emit: `LoadingUpdateView`,
                permission: `default`
            }
            ]
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_SECTION`)
        this.init()
    },
    computed: {
        ...mapGetters([`section`, `currentUser`, `sysuser/workers_by_duty`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `worker_name`,
                    label: `姓名`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: false,
                    readonly: true
                },
                {
                    type: `select`,
                    prop: `worker_id`,
                    label: `姓名`,
                    width: `60`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: true,
                    searchable: false,
                    options: this.worker,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]

                },

                {
                    type: `select`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `select`,
                    prop: `enum_worker_duty`,
                    label: `类型`,
                    width: `100`,
                    isListable: true,
                    isCreatable: false,
                    isEditable: false,
                    searchable: true,
                    options: this.sys_enums.WorkerDuty || []
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    options: this[`section`]
                },
                {
                    type: `select`,
                    prop: `dic_attendanceplan_id`,
                    label: `出勤方案`,
                    width: `200`,
                    isListable: true,
                    options: this.dic_attendancePlan_names
                },
                {
                    type: `select`,
                    prop: `dic_attendanceplan_id`,
                    label: `打卡方案`,
                    isListable: true,
                    options: this.dic_attendancePlan_contents
                },
                {
                    type: `integer`,
                    prop: `month_attendance_days`,
                    label: `月出勤天数`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    width: `150`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `textarea`,
                    prop: `evaluate`,
                    label: `评价`,
                    isListable: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24,
                    config: {
                        minRows: 3
                    }
                }

            ]
        },
        worker() {
            let workers = this[`sysuser/workers_by_duty`][`医生`] || []
            let allworkers = workers.concat(this[`sysuser/workers_by_duty`][`护士`])
            return allworkers
        }
        // workerDutyOptions() {
        //     if (this.$root.IsWorkerByDuty == `0`) {
        //         return []
        //     } else if (this.$root.IsWorkerByDuty == `1`) {
        //         return this.sys_enums.Enum_WorkerDuty
        //     }
        // }
    },
    mounted() {},
    methods: {
        init() {
            this.loadDicAttendancePlans()
        },
        loadDicAttendancePlans() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/AttendancePlan/Get`)
                req.then(data => {
                    this.dic_attendancePlan_names = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.name
                        }
                    })
                    this.dic_attendancePlan_contents = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.content
                        }
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Attendance/Index.vue